import { Grid, Button } from "@mui/material";

import FeatureErrorBoundary from "../../atoms/FeatureErrorBoundary";
import CollapsibleAlert from "../../atoms/notifications/CollapsibleAlert";
import QuickbooksCard from "../../modules/settings/QuickbooksCard";
import PlaidCard from "../../modules/settings/PlaidCard";

import {
  useStarterTierSubscriptionFlags,
  useSubscriptionType
} from "../../../helpers/hooks/companyData";
import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

const Integrations = () => {
  const { openCommunicationCenter } = usePlatformLayoutContext();
  const [{ isPaid }] = useSubscriptionType("saas");
  const { isStarterTier } = useStarterTierSubscriptionFlags();

  return (
    <FeatureErrorBoundary featureName="Integrations">
      <Grid container spacing={2} alignItems="stretch">
        {(!isPaid || isStarterTier) && (
          <Grid item xs={12}>
            <CollapsibleAlert
              title="These are accounting integrations features"
              subtitle="If you would like to have access to integrations, upgrade your plan"
              action={
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => openCommunicationCenter("sales")}
                >
                  Upgrade my plan
                </Button>
              }
            />
          </Grid>
        )}
        <Grid item container direction="column" spacing={2} xs={6}>
          <Grid item>
            <QuickbooksCard />
          </Grid>
          <Grid item>
            <PlaidCard />
          </Grid>
        </Grid>
      </Grid>
    </FeatureErrorBoundary>
  );
};
export default Integrations;
